import styled, { css } from "styled-components"

export const Wrapper = styled.div`
  width: 83.3%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* background: linear-gradient(121.74deg, #eae69c -25.01%, #bb913c 31.15%); */
  background: linear-gradient(
    133.89deg,
    #bb913c 8%,
    #eae69c 29.98%,
    #b6872d 60.48%
  );

  @media (max-width: 1149px) {
    width: 82.5%;
    min-height: unset;
    height: auto;
    flex-direction: column;
  }

  @media (max-width: 799px) {
    width: 100%;
    height: auto;
  }

  img {
    width: 50%;
    ${props =>
      props.imageFirst
        ? css`
            order: 1;
          `
        : css`
            order: 2;
          `}

    @media (max-width: 1149px) {
      order: 2;
      aspect-ratio: 4/3;
      width: 100%;
      height: unset;
    }
  }
`

export const Main = styled.div`
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 64px 0;
  gap: 93px;

  & > ${Wrapper}:nth-child(2) {
    background: linear-gradient(
      133.89deg,
      #bb913c 32%,
      #eae69c 66.98%,
      #b6872d 97.48%
    );

    @media (max-width: 1149px) {
      background: linear-gradient(
        133.89deg,
        #bb913c 3%,
        #eae69c 29.98%,
        #b6872d 69.48%
      );
    }
  }
`

export const TextBox = styled.div`
  padding: 30px 80px;
  height: 100%;
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 24px;

  hr {
    width: 100%;
    border: 1px solid #030303;
  }

  @media (max-width: 1600px) {
    padding: 30px 50px;
  }

  @media (max-width: 1450px) {
    padding: 30px 40px;
  }

  @media (max-width: 1450px) {
    padding: 30px 60px;
  }

  @media (max-width: 1300px) {
    padding: 30px 40px;
  }

  ${props =>
    props.imageFirst
      ? css`
          order: 2;
          @media (max-width: 1149px) {
            order: 1;
          }
        `
      : css`
          order: 1;
          @media (max-width: 1149px) {
            order: 1;
          }
        `}

  @media (min-width: 1400px) {
    gap: 30px;
  }

  p {
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2.1rem;
    letter-spacing: 0.06em;
    color: #030303;
  }

  @media (max-width: 1200px) {
    p {
      font-size: 1.3rem;
      line-height: 1.9rem;
      letter-spacing: 0.06em;
      color: #030303;
    }
  }

  @media (max-width: 1149px) {
    width: 100%;
    padding: 40px;
    margin: 0;
    gap: 30px;

    p {
      font-size: 1.4rem;
      line-height: 2.1rem;
      letter-spacing: 0.06em;
      color: #030303;
    }
  }

  @media (max-width: 799px) {
    height: auto;
  }
`
